import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "environments/environment";
import { SubcategoryWithCategory } from "app/_models/subcategories";
import { UserModel } from "app/_models/user-model";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CrudSubcategoryService {
  private readonly _baseUrl: string;
  private readonly _refreshrequired = new Subject<void>();

  constructor(private readonly http: HttpClient) {
    this._baseUrl = environment.baseUrl;
  }

  currentUser: UserModel;

  get Refreshrequired() {
    return this._refreshrequired;
  }

  getSubactegoriesWithCategories() {
    return this.http.get<SubcategoryWithCategory[]>(
      this._baseUrl + "Product/GetAllActiveSubcategoriesWithCategory"
    );
  }

  getPagedSubactegoriesWithCategories(model: any): Observable<any> {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });
    let options = { headers: headers, withCredentials: true };
    return this.http.post<any>(
      `${this._baseUrl}Product/GetAllActiveSubcategoriesWithCategory`,
      model,
      options
    );
  }

  deleteSubCategory(subCategoryId: number): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let model = { id: subCategoryId, updatedBy: this.currentUser.userId };
    return this.http
      .post<any>(this._baseUrl + "Product/DeleteSubCategory", model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  addSubCategory(
    model:any
  ): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    return this.http
      .post<any>(this._baseUrl + "Product/AddProductSubCategory", model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  updateSubCategory(
    subCategoryId: number,
    productId: number,
    categoryId: number,
    subCategoryName: string,
    description: string,
    isConsumable: boolean,
  ): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let model = {
      subCategoryId: subCategoryId,
      productId: productId,
      categoryId: categoryId,
      subCategoryName: subCategoryName,
      description: description,
      updatedBy: this.currentUser.userId,
      isConsumable: isConsumable
    };
    return this.http
      .post<any>(this._baseUrl + "Product/UpdateSubCategory", model)
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  getSampleCatSubcatFile(): any {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.http.get(
      this._baseUrl + "Product/GetSampleCatSubcatFile",
      options
    );
  }


  uploadFileToBulkCreateCatSubcat(model: any): Observable<any> {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(
      this._baseUrl + "Product/UploadToBulkCatSubactegories",
      model, options
    );
  }




}
